import type { ComponentType } from '@angular/cdk/portal';
import type { TemplateRef } from '@angular/core';

export enum PalantirModalSizeEnum {
  '2x-large' = '2x-large',
  'large' = 'large',
  'medium' = 'medium',
  'small' = 'small',
  'x-large' = 'x-large',
}

export type PalantirModalSize = keyof typeof PalantirModalSizeEnum;

export interface PalantirModalConfirmation<T = ComponentType<unknown> | TemplateRef<unknown>> {
  /**
   * Funcao para confirmar a acao de fechamento do modal
   */
  confirm?(): Promise<boolean> | boolean;

  /**
   * Funcao para avaliar se a confirmacao deve ser exibida
   */
  evaluate(componentInstance: T): boolean;
}

export interface PalantirModalOptions<
  T = ComponentType<unknown> | TemplateRef<unknown>,
  R = T extends ComponentType<infer C> | TemplateRef<infer C> ? C : unknown,
> {
  autoFocus?: boolean;
  canClose?(): Promise<boolean> | boolean;

  /**
   * Confirmação antes de fechar o modal
   */
  confirmation?: PalantirModalConfirmation<R>;
  /**
   * Data para ser passada para o modal, deve ser utilizável com spread operator
   *
   * @example \{ title: 'Título do modal' \}
   *
   * - Caso seja passado uma array, string ou qualquer outro tipo de dado, ele sera convertido para key-value
   * @example ['title', 'Título do modal'] → \{ 0: 'title', 1: 'Título do modal' \}
   * @example 'title' → \{ 0: 't', 1: 'i', 2: 't', 3: 'l', 4: 'e' \}
   */
  data?: Record<any, any>;
  size?: PalantirModalSize;
}
